import { memo } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { FilterContentContainer } from "app/pages/sales-intelligence/modules/advanced-search-filtering/components/styles";
import SignalsManagementButton from "app/pages/sales-intelligence/sub-modules/signals/components/buttons/SignalsManagementButton/SignalsManagementButton";
import type { SignalsEmptyStateProps } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalsEmptyState/types";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

const SignalsEmptyStateText = ({ signalType, onAddSignalClick }: SignalsEmptyStateProps) => {
    const { translate } = useTranslate();

    return (
        <FilterContentContainer
            justifyContent="center"
            alignItems="center"
        >
            <Text
                fontVariant="body2"
                color={colorsPalettes.carbon[300]}
            >
                {translate(signalsI18nKeys.emptyStateText(signalType))}
            </Text>

            <Flex
                gap="8px"
                justifyContent="space-between"
            >
                {typeof onAddSignalClick === "function" ? (
                    <SignalsManagementButton
                        isSignalsListEmpty
                        emptyListBtnText={signalsI18nKeys.addSignal.shortCta}
                        onClick={(_e) => onAddSignalClick()}
                    />
                ) : null}
            </Flex>
        </FilterContentContainer>
    );
};

export default memo(SignalsEmptyStateText);
